import ExpandableText from './ExpandableText';

export default ExpandableText;
